import { genComponentStyleHook, type FullToken } from '../geek/styleUtil'
import {
  purple,
  primaryGradient,
  primaryGradientHover,
  glowSm,
  glowMd,
  transition,
  shimmerKeyframes,
} from './glowUtil'
import { DOT_PREFIX } from './constant'

export default genComponentStyleHook(['Button', 'heroTheme'], (token: FullToken) => {
  const { componentCls } = token

  return {
    [`${componentCls}${DOT_PREFIX}`]: {
      transition,
      borderRadius: 14,
      fontWeight: 500,

      // ── Primary 按钮：渐变 + glow ──
      [`&${componentCls}-primary`]: {
        [`&:not(${componentCls}-dangerous)`]: {
          background: `${primaryGradient} !important`,
          border: 'none',
          boxShadow: `0 2px 8px ${purple[600]}35`,
          position: 'relative' as const,
          overflow: 'hidden',

          // shimmer 光泽层
          '&:after': {
            content: '""',
            position: 'absolute',
            inset: 0,
            background: `linear-gradient(105deg, transparent 40%, rgba(255,255,255,0.18) 45%, rgba(255,255,255,0.25) 50%, rgba(255,255,255,0.18) 55%, transparent 60%)`,
            backgroundSize: '200% 100%',
            animationName: shimmerKeyframes,
            animationDuration: '3s',
            animationIterationCount: 'infinite',
            animationTimingFunction: 'ease-in-out',
            borderRadius: 'inherit',
            pointerEvents: 'none',
          },

          '&:not(:disabled):hover': {
            background: `${primaryGradientHover} !important`,
            boxShadow: glowMd,
            transform: 'translateY(-1px)',
          },
          '&:not(:disabled):active': {
            transform: 'translateY(0) scale(0.98)',
            boxShadow: glowSm,
          },
          '&:disabled': {
            opacity: 0.55,
            '&:after': { display: 'none' },
          },
        },
      },

      // ── Default 按钮：hover 时紫色边框 + 微光 ──
      [`&${componentCls}-default`]: {
        [`&:not(${componentCls}-dangerous)`]: {
          '&:not(:disabled):hover': {
            borderColor: `${purple[500]} !important`,
            color: `${purple[600]} !important`,
            boxShadow: `0 0 0 1px ${purple[500]}20, 0 2px 8px ${purple[500]}15`,
            transform: 'translateY(-1px)',
          },
          '&:not(:disabled):active': {
            borderColor: `${purple[700]} !important`,
            color: `${purple[700]} !important`,
            transform: 'translateY(0)',
          },
        },
      },

      // ── Text / Link 按钮 ──
      [`&${componentCls}-text, &${componentCls}-link`]: {
        '&:not(:disabled):hover': {
          color: `${purple[500]} !important`,
          background: `${purple[500]}08 !important`,
        },
      },
    },
  }
})
